export enum AlertParamType {
  TEMPERATURE_ALERT = 'temperatureAlert',
  FREQUENCE_COUNTER_ALERT = 'frequenceCounterAlert',
  CLICK_COUNTER_ALERT = 'clickCounterAlert',
  WATER_MOVEMENT_ALERT = 'waterMovementAlert',
  WATER_FLOW_ALERT = 'waterFlowAlert',
  HUMIDITY_ALERT = 'humidityAlert',
  BATTERY_ALERT = 'batteryAlert',
  DEFAULT_PUMP_ALERT = 'defaultPumpAlert',
  DEFAULT_COM_ALERT = 'defaultComAlert',
  DEFAULT_MANUAL_ALERT = 'defaultManualAlert',
  DEFAULT_CRITICAL_ALERT = 'defaultCriticalAlert',
  OTHER_DEFAULT_ALERT = 'otherDefaultAlert',
  DEVICE_DISCONNECTED_ALERT = 'deviceDisconnectedAlert',
  DEFAULT_CTA_ALERT = 'defaultCtaAlert',
  DEFAULT_ELEC_ALERT = 'defaultElecAlert',
  DEFAULT_CHILLER_ALERT = 'defaultChillerAlert',
  DEFAULT_FLOW_ALERT = 'defaultFlowAlert',
  DEFAULT_GENERAL_ALERT = 'defaultGeneralAlert',
  DEFAULT_VMC_ALERT = 'defaultVMCAlert',
  MEDICAL_FLUID_ALERT = 'medicalFluidAlert',
  CHLORINE_ALERT = 'chlorineAlert',
  PH_ALERT = 'phAlert',
  CO2_ALERT = 'co2Alert',
  TVOC_ALERT = 'tvocAlert',
}
